angular
    .module('festzelt-os.modules.tickets.templates')
    .factory('TicketTemplate', [
        'locale',
        'Resource',
        TicketTemplate
    ]);

function TicketTemplate(locale, Resource) {
    return Resource.make('tickets/templates');
}



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/factories/template.js